

// Focus search when opened
$('.js-search-ic').click(function (){
    $('.woodmart-ajax-search input[type="text"]')[0].focus()
})
